import Divider from 'antd/es/divider';
import styled from 'styled-components';
export const ApplicationProgressInfosBlock = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `0 ${theme.spacing.lg}px`};
  width: 100%;
  gap: 20px;
`;
export const ApplicationProgressionDivider = styled(Divider) `
  && {
    border-top-width: 1px;
    border-top-color: ${({ theme }) => theme.colors.grey_4};
  }
`;
export const ApplicationProgressionContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  padding-inline: 54px;
`;
export const ApplicationProgressionContent = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  padding-inline: 54px;
`;
